// extracted by mini-css-extract-plugin
module.exports = {"nft":"index_nft__Ee3_r","dot":"index_dot__oe_ky"};